import service from '@/store/services/settings/guidances-service';

const state = {
    list: {},
    workplaces: {},
    manageShift: {},
    guidance: {},
    statistics: {},
    meta: {},
    listState: null,
    url: null,
    pdfPreview: null,
    pdfDownload: null,
    pdfGenerating: false,
    pdfError: null
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, guidance) => {
        state.guidance = guidance;
    },
    SET_WORKPLACES: (state, workplaces) => {
        state.workplaces = workplaces;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    },
    SET_STATISTICS: (state, statistics) => {
        state.statistics = statistics;
    },
    SET_PDF_PREVIEW(state, data) {
        state.pdfPreview = data;
    },
    SET_PDF_DOWNLOAD(state, data) {
        state.pdfDownload = data;
    },
    SET_PDF_GENERATING(state, status) {
        state.pdfGenerating = status;
    },
    SET_PDF_ERROR(state, error) {
        state.pdfError = error;
    },
    CLEAR_PDF_DATA(state) {
        state.pdfPreview = null;
        state.pdfDownload = null;
        state.pdfError = null;
    },
    SET_LIST_STATE: (state, listState) => {
        state.listState = listState;
    },

    CLEAR_LIST_STATE: (state) => {
        state.listState = null;
    },
};

const actions = {
    list({commit, dispatch}, params) {
        return service.list(params)
            .then(({list, meta}) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    workplaces({commit, dispatch}, params) {
        return service.workplaces(params)
            .then(({list, meta}) => {
                commit('SET_WORKPLACES', list.workplaces);
                commit('SET_META', meta);
            });
    },

    manageShift({commit, dispatch}, params) {
        return service.manageShift(params)
            .then(({list, meta}) => {
                commit('SET_WORKPLACES', list.workplaces);
                commit('SET_META', meta);
            });
    },

    get({commit, dispatch}, params) {
        return service.get(params)
            .then(guidance => {
                commit('SET_RESOURCE', guidance);
            });
    },

    view({commit, dispatch}, params) {
        return service.view(params)
            .then(guidance => {
                commit('SET_RESOURCE', guidance);
            });
    },

    show({commit, dispatch}, params) {
        return service.view(params)
            .then(guidance => {
                commit('SET_RESOURCE', guidance);
            });
    },

    add({commit, dispatch}, params) {
        return service.add(params)
            .then((guidance) => {
                commit('SET_RESOURCE', guidance);
            });
    },

    update({commit, dispatch}, params) {
        return service.update(params)
            .then((guidance) => {
                commit('SET_RESOURCE', guidance);
            });
    },

    update1({commit, dispatch}, params) {
        return service.update1(params)
            .then((guidance) => {
                commit('SET_RESOURCE', guidance);
            });
    },

    destroy({commit, dispatch}, params) {
        return service.destroy(params);
    },

    generateSchedule({commit, dispatch}, params) {
        return service.generateSchedule(params)
            .then(guidance => {
                commit('SET_RESOURCE', guidance);
            });
    },

    generateTakeon({commit, dispatch}, params) {
        return service.generateTakeon(params)
            .then(({list, meta}) => {
                commit('SET_WORKPLACES', list.workplaces);
                commit('SET_META', meta);
            });
    },

    statusStatistics({commit, dispatch}, params) {
        return service.getStatusStatistics(params)
            .then((statistics) => {
                commit('SET_STATISTICS', statistics);
            });
    },

    pdfPreview({commit, dispatch}, params) {
        return service.pdfPreview(params)
            .then(pdf => {
                commit('SET_PDF', pdf);
            });
    },

    pdfRegenerate({commit, dispatch}, params) {
        return service.pdfRegenerate(params)
            .then(pdf => {
                commit('SET_PDF', pdf);
            });
    },

    async pdfDownloadAction({commit, state}, {guidanceId, sections = []}) {
        try {
            commit('SET_PDF_GENERATING', true);
            commit('SET_PDF_ERROR', null);

            const response = await service.pdfDownload(guidanceId, sections);

            commit('SET_PDF_DOWNLOAD', response);

            return response;
        } catch (error) {
            commit('SET_PDF_ERROR', error);
            throw error;
        } finally {
            commit('SET_PDF_GENERATING', false);
        }
    },

    async pdfPreviewAction({commit, state}, {guidanceId, sections = []}) {
        try {
            commit('SET_PDF_GENERATING', true);
            commit('SET_PDF_ERROR', null);

            // Call service and get full response
            const response = await service.pdfPreview(guidanceId, sections);

            // Store the full response in state
            commit('SET_PDF_PREVIEW', response);

            return response;
        } catch (error) {
            commit('SET_PDF_ERROR', error);
            throw error;
        } finally {
            commit('SET_PDF_GENERATING', false);
        }
    },

    async pdfRegenerateAction({commit, dispatch}, guidanceId) {
        try {
            commit('SET_PDF_GENERATING', true);
            commit('SET_PDF_ERROR', null);

            const response = await service.pdfRegenerate(guidanceId);

            // Clear cached PDF data after regeneration
            commit('CLEAR_PDF_DATA');

            return response;
        } catch (error) {
            commit('SET_PDF_ERROR', error);
            throw error;
        } finally {
            commit('SET_PDF_GENERATING', false);
        }
    },

    async pdfGenerateAction({commit, state}, guidanceId) {
        try {
            commit('SET_PDF_GENERATING', true);
            commit('SET_PDF_ERROR', null);

            const response = await service.pdfGenerate(guidanceId);

            return response;
        } catch (error) {
            commit('SET_PDF_ERROR', error);
            throw error;
        } finally {
            commit('SET_PDF_GENERATING', false);
        }
    },

    /**
     * Clear PDF data from store
     */
    clearPdfData({commit}) {
        commit('CLEAR_PDF_DATA');
    },

    async updateAllowManual({ commit }, { id, allow_manual }) {
        return await service.updateAllowManual(id, allow_manual);
    }
};
const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    listState: state => state.listState,
    workplaces: state => state.workplaces,
    guidance: state => state.guidance,
    statistics: state => state.statistics,
    dropdown: (state) => {
        return state.list.map(guidance => ({
            id: guidance.id,
            name: guidance.name,
            guidance_number: guidance.guidance_number,
        }));
    },
    url: state => state.url,
    pdfPreview: state => state.pdfPreview,
    pdfDownload: state => state.pdfDownload,
    pdfGenerating: state => state.pdfGenerating,
    pdfError: state => state.pdfError
};

const guidances = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default guidances;
